// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"237c88d3","453":"1be62aff","455":"632662f0","977":"01874b5d"}[chunkId] + ".chunk.js";
};